"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_generatedBorrowingBaseReport = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const configSchema = __importStar(require("./schema/UIConfig.jsonschema.generated.json"));
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, configSchema);
// create a new UI node of this type.
const createNewNode = ({ id, suggestedSerialNumber, }) => {
    const friendlyName = `Borrowing Base Report ${suggestedSerialNumber}`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: lodash_1.default.camelCase(friendlyName),
            description: 'this is borrowing base report',
            createServicerReport: false,
        },
    };
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const allowedInputNodes = [
        'file_generatedReceivableResponseTape',
        'file_generatedCashBalanceFeed',
        'file_generatedCovenantLoanTape',
        'file_intermediateTape',
        'file_assignedRepaymentTape',
        // @REPAY TODO: remove "generated" once rolled over
        'file_generatedRepaymentTape',
    ];
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: (uiNode) => allowedInputNodes.some((type) => type === uiNode.nodeType),
        getUINode,
        minInputs: 1,
        maxInputs: 100,
        minOutputs: 1,
        maxOutputs: 1,
    });
    return errors;
};
const getTapeDefinition = ({ tapeBuilder, artifactId, }) => {
    const tapeDefinitionResult = tapeBuilder.generateTapeDefinition(artifactId);
    (0, common_1.finleyAssert)(tapeDefinitionResult.isValid, `tapeDefinitionResult is not valid for ${artifactId}`);
    (0, common_1.finleyAssert)(tapeDefinitionResult.data, `No definition found for ${artifactId}`);
    return tapeDefinitionResult.data;
};
// validate given IntermediateRecord when funding submission node is available.
const validateIntermediateTape = ({ graph, tape, tapeBuilder, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'borrowingBaseReport', 'node is not a borrowing base report');
    // Get input tape IDs
    const inputTapeIds = (0, utils_1.getInputTapeIds)({ tapeId: tape.id, graph });
    // Find intermediate nodes, if any exist
    const intermediateTapes = graph.dataTapes.filter((dataTape) => inputTapeIds.includes(dataTape.id) &&
        dataTape.type === 'intermediateTape');
    // If intermediate nodes are found, validate that only 1 exists (assumption: funding submission node is the only intermediate tape at this time)
    (0, common_1.finleyAssert)(intermediateTapes.length <= 1, 'expected maximum of 1 intermediate tape as input for borrowing base report node');
    const fundingSubmissionErrors = [];
    // If no submission tape is available, return empty array for validation error
    if (intermediateTapes.length === 0) {
        return fundingSubmissionErrors;
    }
    // At this point, only 1 submission tape will exist - validate fields and return errors
    const fundingSubmissionTape = intermediateTapes[0];
    const tapeDefinition = getTapeDefinition({
        tapeBuilder,
        artifactId: fundingSubmissionTape.id,
    });
    const requiredFields = new Map([
        ['drawRequest#totalAmount', ['float']],
        ['drawRequest#targetFundingDate', ['date']],
        ['collectionsRecycle#totalAmount', ['float']],
        ['collectionsRecycle#targetFundingDate', ['date']],
        ['collectionsPaydown#totalAmount', ['float']],
        ['collectionsPaydown#targetFundingDate', ['date']],
        ['curePaydown#totalAmount', ['float']],
        ['curePaydown#targetFundingDate', ['date']],
    ]);
    const invalidFieldNames = [];
    const invalidFieldTypes = [];
    tapeDefinition.baseFields.forEach((config) => {
        const { field: fieldName, type: fieldType } = config;
        const validTypes = requiredFields.get(fieldName);
        if (validTypes) {
            if (!validTypes.includes(fieldType)) {
                invalidFieldTypes.push(`${fieldName} must be one of: [${validTypes.join(',')}]`);
            }
            // Remove from field set to return list of missing fields at the end
            requiredFields.delete(fieldName);
        }
        else {
            // Add to list of invalid fields
            invalidFieldNames.push(config.field);
        }
    });
    // Output invalid field types if any
    if (invalidFieldTypes.length > 0) {
        fundingSubmissionErrors.push(`Invalid field types for expected properties: [${invalidFieldTypes.join(', ')}]`);
    }
    // Output invalid field names if any
    if (invalidFieldNames.length > 0) {
        fundingSubmissionErrors.push(`Fields not allowed for funding submission: [${invalidFieldNames.join(', ')}]`);
    }
    // Output missing fields if any
    const missingFields = Array.from(requiredFields.keys());
    if (missingFields.length > 0) {
        fundingSubmissionErrors.push(`Fields missing for funding submission: [${missingFields.join(', ')}]`);
    }
    return fundingSubmissionErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
// eslint-disable-next-line camelcase
exports.file_generatedBorrowingBaseReport = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'Borrowing Base',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    // operatin nodes dont render badges.
    badgeTexts: ['BorrowingBase'],
    // schema to validate the configuration against.
    configSchema,
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map